import { QueryKey, useQuery } from "react-query";
import { getInspections as getInspections } from "../../api/inspections/getInspections";
import useNetworkHeaders from "../../../../hooks/useNetworkHeaders";

interface IUseInspections {
  recordId?: string | number;
  inspectableId?: string | number;
  enabled?: boolean;
}
export default function useInspections({ recordId, inspectableId, enabled = true }: IUseInspections = {}) {
  const queryKey = InspectionsQueryKey({ recordId, inspectableId });

  const networkHeaders = useNetworkHeaders();
  const citizenInspectionsQuery = useQuery(
    queryKey,
    getInspections(networkHeaders, recordId?.toString(), inspectableId?.toString()),
    {
      enabled: enabled,
    },
  );
  return {
    citizenInspectionsQuery,
    queryKey,
    isLoading: citizenInspectionsQuery.isLoading,
    isFetching: citizenInspectionsQuery.isFetching,
  };
}

export function InspectionsQueryKey({ recordId, inspectableId }: IUseInspections = {}): QueryKey {
  return ["inspections-query", recordId?.toString(), inspectableId?.toString()].filter((key) => key);
}
